
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.05128 0H1V20H3.05128V17.9488H4.99998V20H15V0H4.99998V2.05131H3.05128V0ZM4.99998 13.3333V15.8975H3.05128V13.3333H4.99998ZM4.99998 8.71795V11.282H3.05128V8.71795H4.99998ZM4.99998 4.10259V6.66667H3.05128V4.10259H4.99998ZM15 2.05132V4.1026H17.0513V6.66667H15V8.71796H17.0513V11.282H15V13.3333H17.0513V15.8974H15V17.9487H17.0513L17.0513 20H19.1026V0H17.0513L17.0513 2.05132H15Z"}})])
          )
        }
      }
    